import React from "react";
import { useLocalReactionStore } from "designSystem/hooks";
import { ManageFashionInspirationStore, ManageFashionInspirationStoreContext } from "../../ManageFashionInspirationStore";
import FashionInspirationPaneHeader from "./FashionInspirationPaneHeader";
import FashionInspirationPaneBody from "./FashionInspirationPaneBody";
import { ErrorBoundary, useErrorBoundary } from "react-error-boundary";
import { FlexColumn } from "designSystem/index";
import { ErrorFallback } from "../errorFallback/ErrorFallback";
import { fetchFashionInspirationProperties } from "../../api";

const FashionInspirationPaneWithStore = () => {
	const { showBoundary } = useErrorBoundary();
	const manageFashionInspirationStore = useLocalReactionStore(
		async () => {
			try {
				const properties = await fetchFashionInspirationProperties();

				return new ManageFashionInspirationStore(properties);
			} catch (error) {
				showBoundary(error);
			}
		});

	return (
		<FlexColumn>

			{manageFashionInspirationStore && (
				<ManageFashionInspirationStoreContext.Provider value={manageFashionInspirationStore}>
					<FashionInspirationPaneHeader />
					<FashionInspirationPaneBody />
				</ManageFashionInspirationStoreContext.Provider>
			)}
		</FlexColumn>
	);
};

const FashionInspirationPane = () => {
	return (
		<ErrorBoundary FallbackComponent={ErrorFallback}>
			<FashionInspirationPaneWithStore />
		</ErrorBoundary>
	);
};

export default FashionInspirationPane;
